import { CcfBox } from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';

/* eslint-disable-next-line */
export interface CcfWemTableProps {
  columns: any;
  tableHeaderText?: string;
  noDataFound?: any;
}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: 'none',
      height: '100%',
    },
    '& .MuiDataGrid-columnHeaderWrapper': {
      height: '36px',
    },
    '& .MuiDataGrid-columnHeaders': {
      border: '1px solid #d2d8db',
      borderRadius: '0px',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      height: '1px !important',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526b7a',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 600,
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: '#333333',
    },
  },
  searchInput: {
    '&.MuiOutlinedInput-inputAdornedEnd': {
      paddingBottom: '7.5px',
    },
  },
});

/**
 * CcfWemTable - used to display wem DataGrid Table
 * @param props - CcfWemTable
 * @example `<CcfWemTable />`
 */
export function CcfWemTable(props: CcfWemTableProps) {
  const classes = useStyles();
  return (
    <CcfBox className={styles.tableBlock}>
      <CcfBox className={styles.tableHeaderTextBlock}>
        {props.tableHeaderText}
      </CcfBox>
      <CcfBox
        className={classes.root}
        style={{
          height: 'inherit',
          backgroundColor: '#FFFF',
        }}
      >
        {' '}
        <DataGrid
          rows={[]}
          autoHeight
          columns={props.columns}
          rowHeight={36}
          headerHeight={36}
          disableSelectionOnClick
          hideFooterPagination
          hideFooterSelectedRowCount
          hideFooter
          getRowClassName={(params: any) => `styledrows`}
          components={{
            NoRowsOverlay: () => props?.noDataFound,
          }}
          sx={{ '& .MuiDataGrid-columnSeparator': { display: 'none' } }}
          disableColumnSelector
        />
      </CcfBox>
    </CcfBox>
  );
}
